(function() {
  const SELECTOR_CONTAINER = '[data-product-related]';
  const SELECTOR_PLACEHOLDER = '[data-product-related-placeholder]';
  const TEMPLATE_SELECTOR = '[data-api-related-inline-template]';

  function loadRelatedProducts(container) {
    const placeholder = container.querySelector(SELECTOR_PLACEHOLDER);
    if (!placeholder) return;

    const productId = container.getAttribute('data-product-id');
    const limit = container.getAttribute('data-limit') || '4';
    const layout = container.getAttribute('data-layout') || 'stacked';

    const url = `${window.theme?.routes?.product_recommendations_url || '/recommendations/products'}?section_id=api-product-recommendation-inline&product_id=${productId}&limit=${limit}&intent=related`;

    fetch(url)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const template = doc.querySelector(TEMPLATE_SELECTOR);
        if (!template || !template.innerHTML.trim()) {
          placeholder.innerHTML = '';
          return;
        }

        const temp = document.createElement('div');
        temp.innerHTML = template.innerHTML;
        const itemsWrapper = temp.querySelector('.product__related__items');
        const isEmpty = temp.querySelector('.product__related__empty');

        if (isEmpty) {
          placeholder.innerHTML = '';
          container.classList.add('product__related--empty');
          return;
        }

        if (layout === 'slider' && itemsWrapper && itemsWrapper.children.length > 0) {
          var sliderWrap = placeholder.parentNode;
          var sliderComponent = document.createElement('slider-component');
          sliderComponent.className = 'product__related__slider';
          sliderComponent.setAttribute('data-slider', '');
          sliderComponent.setAttribute('data-dots', container.getAttribute('data-dots') || 'hidden');
          var autoplay = container.getAttribute('data-autoplay') === '1';
          var autoplaySpeed = container.getAttribute('data-autoplay-speed') || '8000';
          sliderComponent.setAttribute('data-options', JSON.stringify({
            autoPlay: autoplay ? parseInt(autoplaySpeed, 10) : false,
            prevNextButtons: true,
            pageDots: true
          }));
          while (itemsWrapper.firstChild) {
            sliderComponent.appendChild(itemsWrapper.firstChild);
          }
          sliderWrap.parentNode.replaceChild(sliderComponent, sliderWrap);
        } else if (itemsWrapper) {
          var parent = placeholder.parentNode;
          while (itemsWrapper.firstChild) {
            parent.insertBefore(itemsWrapper.firstChild, placeholder);
          }
          placeholder.remove();
        } else {
          placeholder.innerHTML = '';
        }
      })
      .catch(function() {
        placeholder.innerHTML = '';
      });
  }

  function init() {
    if (typeof window.theme === 'undefined') {
      window.theme = window.theme || {};
      window.theme.routes = window.theme.routes || {};
      if (!window.theme.routes.product_recommendations_url) {
        var script = document.querySelector('script[data-theme-routes]');
        if (script) {
          try {
            var data = JSON.parse(script.textContent);
            if (data.product_recommendations_url) window.theme.routes.product_recommendations_url = data.product_recommendations_url;
          } catch (e) {}
        }
      }
    }

    document.querySelectorAll(SELECTOR_CONTAINER).forEach(loadRelatedProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    document.querySelectorAll(SELECTOR_CONTAINER).forEach(loadRelatedProducts);
  });
})();
